var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.359 7.575c.13.108.213.256.234.417l.239 1.856a.175.175 0 0 0 .173.152h3.99a.175.175 0 0 0 .174-.152l.238-1.857a.648.648 0 0 1 .234-.416C15.507 6.84 16.001 5.8 16 4.71 15.99 2.653 14.192.99 11.983 1 9.773 1.009 7.991 2.684 8 4.742c-.003 1.082.492 2.113 1.359 2.833z",
    fill: "#525266"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 10h2.5v11h-2.5V10z",
    fill: "#525266"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.948 18.019H7.052c-.87 0-1.552.518-1.552 1.13v.773c0 .053.044.097.097.097h12.805a.097.097 0 0 0 .098-.097v-.773c0-.612-.681-1.13-1.552-1.13z",
    fill: "#525266"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.497 20H4.503c-.823-.005-1.495.685-1.503 1.544v1.358c0 .054.044.098.097.098h17.805a.097.097 0 0 0 .098-.098v-1.358c-.009-.86-.68-1.55-1.503-1.544z",
    fill: "#525266"
  })));
};
export default __webpack_public_path__ + "static/media/icon-manual.83096ec8.svg";
export { SvgComponent as ReactComponent };